module.exports = __webpack_public_path__ + "images/f9ac21c295ba0beb55d076ccb065af75.svg";